import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";

import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const TmobilejSimInfoList = ({
  data,
  meta,
  client,
  loading,
  handleSort,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handleFilterChange,
  handlePageSizeChange,
  ...props
}) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "msisdn",
      headerName: "MSISDN",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"MSISDN"}
            handleClick={() => handleColumnClick("msisdn")}
          />
        ) : (
          "MSISDN"
        ),
    },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Status"}
            handleClick={() => handleColumnClick("status")}
          />
        ) : (
          "Status"
        ),
    },
    {
      field: "extra_data.message_route_id",
      headerName: "Message Route ID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Message Route ID"}
            handleClick={() => handleColumnClick("extra_data.message_route_id")}
          />
        ) : (
          "Message Route ID"
        ),

      valueGetter: (params) => params.row?.extra_data?.message_route_id || "-",
    },
    {
      field: "extra_data.message_enabled",
      headerName: "Message Enabled",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Message Enabled"}
            handleClick={() => handleColumnClick("extra_data.message_enabled")}
          />
        ) : (
          "Message Enabled"
        ),

      valueGetter: (params) => params.row?.extra_data?.message_enabled || "-",
    },
    {
      field: "extra_data.voice_route_id",
      headerName: "Voice Route ID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Voice Route ID"}
            handleClick={() => handleColumnClick("extra_data.voice_route_id")}
          />
        ) : (
          "Voice Route ID"
        ),

      valueGetter: (params) => params.row?.extra_data?.voice_route_id || "-",
    },
    {
      field: "extra_data.voice_enabled",
      headerName: "Voice Enabled",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Voice Enabled"}
            handleClick={() => handleColumnClick("extra_data.voice_enabled")}
          />
        ) : (
          "Voice Enabled"
        ),

      valueGetter: (params) => params.row?.extra_data?.voice_enabled || false,
    },
    {
      field: "extra_data.forwarding_number",
      headerName: "Forwarding Number",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Forwarding Number"}
            handleClick={() =>
              handleColumnClick("extra_data.forwarding_number")
            }
          />
        ) : (
          "Forwarding Number"
        ),

      valueGetter: (params) =>
        params.row?.extra_data?.forwarding_number || "-",
    },
    {
      field: "extra_data.mms_message_enabled",
      headerName: "MMS Enabled",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"MMS Enabled"}
            handleClick={() =>
              handleColumnClick("extra_data.mms_message_enabled")
            }
          />
        ) : (
          "MMS Enabled"
        ),

      valueGetter: (params) =>
        params.row?.extra_data?.mms_message_enabled || false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      client={client}
      columns={
        client ? columns.map((val) => ({ ...val, sortable: true })) : columns
      }
      metaData={meta}
      handleRowClick={null}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      {...props}
    />
  );
};

export default TmobilejSimInfoList;
